export default __webpack_public_path__ + "static/media/PenguinSmart_Logo_ENG_Vertical_Black.4245e00f.png";